module.exports = __webpack_public_path__ + "img/use_icon.dfb959d.png";